<template>
  <div class="error">
    <div class="pic">
      <img src="@/assets/images/404.svg" />
    </div>
    <h2>很抱歉，您要访问的页面不存在！</h2>
  </div>
</template>

<script>
export default {
  name: "notFound",
  data() {
    return {};
  },
  created() {
    this.$store.commit("SET_THEME", "404");
  }
};
</script>

<style scoped>
.error {
  width: 600px;
  height: 400px;
  text-align: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}
.error .pic {
  width: 600px;
  height: 300px;
}
.error .pic img {
  width: 100%;
  height: 100%;
}
.error h2 {
  font-size: 24px;
  margin-top: -20px;
}
</style>